type TMode = 'sea' | 'air' | 'seaAir' | 'rail'

export const modeTerm: Record<TMode, string> = {
  sea: 'common-mode-sea',
  air: 'common-mode-air',
  seaAir: 'common-mode-sea_air',
  rail: 'common-mode-rail',
}
